import { connect, useSelector } from 'react-redux';
import { cmsActions } from '../../reducers/cms.reducer';
import Button from '../common/Button.react';
var NavigationDeleteItem = function NavigationDeleteItem(_ref) {
  var item = _ref.item,
    _ref$setEdit = _ref.setEdit,
    setEdit = _ref$setEdit === void 0 ? null : _ref$setEdit,
    navigationAction = _ref.navigationAction,
    permission = _ref.permission;
  var navigate = useNavigate();
  var cmsNavigation = useSelector(function (s) {
    return s.cms.navigation || {};
  });
  var isValid = function isValid() {
    if (Object.values(cmsNavigation).find(function (x) {
      return x.parentID == item._id;
    })) return false;else return true;
  };
  if (!item) return null;
  return /*#__PURE__*/React.createElement(Button, {
    label: "Delete",
    onClick: function onClick() {
      if (setEdit) setEdit();
      navigationAction({
        formData: {
          app: item.clientApp,
          navID: item._id
        },
        method: 'delete'
      });
      navigate("/".concat(item.clientApp, "/dashboard"));
    },
    disabled: !isValid(),
    requireConfirmation: true,
    type: "delete",
    icon: "lock-icon@3x.png",
    permission: permission
  });
};
var mdtp = {
  navigationAction: cmsActions.navigation
};
export default connect(null, mdtp)(NavigationDeleteItem);